import { URL_SRV_RAIZ } from "../router/Url";

import React from 'react'

export const GetLastDataInsert = ({planta}) => {
  // console.log(planta)
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_SRV_RAIZ+'getlastdatainsert',{
      method: 'POST',
      headers: {
        'authorization': "paico2021",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        planta: planta
      })
    })
    let responsito = await query.json();
    // console.log(responsito)
    if(responsito.data.success){
      resolve(responsito.data.body)
    }else{
      resolve('')
    }
  })
}
